module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_hospital-9746a74111f32b60c51c2d636ab7d1f2.svg";